module.exports = __webpack_public_path__ + "img/curve.1e87caf9.svg";